import type { CollapseProps } from "antd";
import EventTagForm from "./EventTagForm";

export const EventTagContentConstants = {
	INFO: "Genel Bilgiler",
};

export const EventTagItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EventTagContentConstants.INFO,
		children: <EventTagForm />,
	},
];
